// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { SecondaryPage, XxlSpacing, XxxlPadding } from '@alto/design-system';
import { ProgynyUnboxingGuide, useUnboxingGuide } from '@alto/features';
import React from 'react';
import { type Prescription, type Shipment } from '~shared/types';
import { LastRefillCard } from '~web/features/essentials/pages/OrderSuccess/LastRefillCard';
import { OrderSuccessHeader } from '~web/features/essentials/pages/OrderSuccess/OrderSuccessHeader';

type Props = {
  shipment: Shipment;
  isSplitOrder: boolean;
  lastRefillPrescriptions: Prescription[];
};

export const OrderSuccessWithoutProducts = ({ shipment, isSplitOrder, lastRefillPrescriptions }: Props) => {
  const { showUnboxingGuide } = useUnboxingGuide({ shipmentID: shipment?.id });

  return (
    <SecondaryPage
      HeaderContent={
        <XxxlPadding
          leftPadding={SPACING.STATIC.NONE}
          rightPadding={SPACING.STATIC.NONE}
        >
          <OrderSuccessHeader
            shipment={shipment}
            isSplitOrder={isSplitOrder}
          />
          {showUnboxingGuide && (
            <>
              <XxlSpacing />
              <ProgynyUnboxingGuide />
            </>
          )}
        </XxxlPadding>
      }
    >
      {lastRefillPrescriptions.length > 0 && <LastRefillCard prescriptions={lastRefillPrescriptions} />}
    </SecondaryPage>
  );
};
